import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

var globalShop = "";
var objBasket = [];
var shopItems = "";


const ShopList = () => {

    const [shop, setShop] = useState(globalShop);

    const getData = async () => {

      const response = await fetch('https://mucksucker.com:3001/getallproducts', {
        method: "GET",
        headers: { "Content-Type": "application/json" }
      })
      const data = await response.json();
      objBasket = data;
      console.log(objBasket);
      shopItems = objBasket.map((product) =>
      <li key={product.Name} dataid={product.Name}>

        <div className="shopItemContainer">
          <Link className="shopListItem" to={`/productinfo?product=${product.id}`}>
            <img alt="shopListItem" className="shopImg" src={product.img} />
            <div className="shopPriceContainer">
              <p className="shopListTitle">{product.Name}</p>

              <p className="shopListDescription">{product.shopDescription}</p>

              {/* <p className="shopListPrice"> £{(product.price/100).toFixed(2)}</p> */}
            </div>
          </Link>
        </div>

      </li> 
      )
      globalShop = shopItems;
      setShop(shopItems);
    }

    useEffect(()  => {

      getData();

    }, []);

    return (
    <div className="container">

      <h1>Product List</h1>
      <p>
        High pressure dust collection systems are available in various HP ranges. Perfect for variety of dust media including non-ferrous metals, plastics and woods
      </p>
      <div className="basketItemContainer">
        <div className="shopListContainer">
          <ul className="shopListUl">
            {shop}
          </ul>
        </div>
      </div>    

    </div>    
    );
  };
  
  export default ShopList;